// extracted by mini-css-extract-plugin
module.exports = {"Button":"SubscriptionPeriodSwitcher_Button__3qUtP"};